import React from 'react';
import { RedocStandalone } from 'redoc';

import partnershipdocs from './partnershipdocs.json';

function PartnershipDocs() {
    return (
        <div>
            <RedocStandalone spec={partnershipdocs} options={{ scrollYOffset: 100 }} />
        </div>
    );
}

export default PartnershipDocs;
